export default __webpack_public_path__ + "static/media/blog-3.f1a210ac.jpg";